import React, { Component } from 'react';
import { NavLink, Link, withRouter } from "react-router-dom";
import config from './../config';

class PageMenu extends Component {
	constructor(props) {
		super(props);

		this.url = config.vefurApiRoot+'/api/pages/';

		this.state = {
			listData: []
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps, prevState) {

	}

	fetchData() {
		// Sæki gögn til APA
		this.setState({
			listData: []
		});

		fetch(this.url+'?site='+config.site)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					listData: json.results
				});
			}.bind(this));
	}

	render() {
		return (

			<React.Fragment>
				<div className={'menu-links'+(this.props.className ? ' '+this.props.className : '')}>
					{
						this.state.listData.length > 0 &&
						this.state.listData.map(function(item, index) {
							return <NavLink key={index}exact to={item.url}>{item.title}</NavLink>;
						}.bind(this))
					}
					<NavLink className="ml-md-4" to={'/minarskrar'}>Mínar skrár</NavLink>
					<NavLink className="ml-md-4" to={'/hvarer'}>Hvar er?</NavLink> 
				</div>
			</React.Fragment>
		);
	}
}

export default withRouter(PageMenu);



// WEBPACK FOOTER //
// ./src/components/PageMenu.js